import { AxiosResponse } from 'axios'
import { ValidationResponse } from '../types/validation.types'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT, ENTITY_MANAGER_END_POINTS } from '../utils/environment'

export const validateNpi = async (
  term: string,
  providerId?: string,
  caseId?: string
): Promise<AxiosResponse<ValidationResponse | undefined>> => {
  const url = `${API_END_POINT.V0_ENTITY_MANAGER}/${ENTITY_MANAGER_END_POINTS.VALIDATION}/npi`
  return await axiosInstance.get(url, {
    params: {
      term,
      resourceId: providerId,
      resourceType: providerId
        ? ENTITY_MANAGER_END_POINTS.PROVIDER_TYPE
        : undefined,
      caseId,
    },
  })
}

export const validateDea = async (
  dea: string,
  lastName?: string
): Promise<AxiosResponse<ValidationResponse | undefined>> => {
  const url = `${API_END_POINT.V0_ENTITY_MANAGER}/${ENTITY_MANAGER_END_POINTS.VALIDATION}/dea`
  return await axiosInstance.get(url, { params: { dea, lastName } })
}
